// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/feature/v2/feature.v2.proto (package no.jotta.openapi.feature.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * @generated from enum no.jotta.openapi.feature.v2.Feature
 */
export var Feature;
(function (Feature) {
    /**
     * @generated from enum value: UNKNOWN_FEATURE = 0;
     */
    Feature[Feature["UNKNOWN_FEATURE"] = 0] = "UNKNOWN_FEATURE";
    /**
     * @generated from enum value: NEWSLETTER = 1;
     */
    Feature[Feature["NEWSLETTER"] = 1] = "NEWSLETTER";
    /**
     * Whether any visitor can sign up on an open page, or that we an offer a visitor to signup when visiting a public share.
     * ie. some brands are only part of bundles and does not have open signup.
     *
     * @generated from enum value: SIGNUP = 2;
     */
    Feature[Feature["SIGNUP"] = 2] = "SIGNUP";
    /**
     * @generated from enum value: VOUCHER_SIGNUP = 7;
     */
    Feature[Feature["VOUCHER_SIGNUP"] = 7] = "VOUCHER_SIGNUP";
    /**
     * @generated from enum value: PRE_SIGNUP = 9;
     */
    Feature[Feature["PRE_SIGNUP"] = 9] = "PRE_SIGNUP";
    /**
     * @generated from enum value: STRIPE = 3;
     */
    Feature[Feature["STRIPE"] = 3] = "STRIPE";
    /**
     * @generated from enum value: CLI = 4;
     */
    Feature[Feature["CLI"] = 4] = "CLI";
    /**
     * @generated from enum value: VIPPS = 5;
     */
    Feature[Feature["VIPPS"] = 5] = "VIPPS";
    /**
     * @generated from enum value: TWO_FACTOR = 6;
     */
    Feature[Feature["TWO_FACTOR"] = 6] = "TWO_FACTOR";
    /**
     * @generated from enum value: INTERCOM = 8;
     */
    Feature[Feature["INTERCOM"] = 8] = "INTERCOM";
})(Feature || (Feature = {}));
// Retrieve enum metadata with: proto3.getEnumType(Feature)
proto3.util.setEnumType(Feature, "no.jotta.openapi.feature.v2.Feature", [
    { no: 0, name: "UNKNOWN_FEATURE" },
    { no: 1, name: "NEWSLETTER" },
    { no: 2, name: "SIGNUP" },
    { no: 7, name: "VOUCHER_SIGNUP" },
    { no: 9, name: "PRE_SIGNUP" },
    { no: 3, name: "STRIPE" },
    { no: 4, name: "CLI" },
    { no: 5, name: "VIPPS" },
    { no: 6, name: "TWO_FACTOR" },
    { no: 8, name: "INTERCOM" },
]);
/**
 * @generated from message no.jotta.openapi.feature.v2.GetFeatureTogglesRequest
 */
export class GetFeatureTogglesRequest extends Message {
    /**
     * @generated from field: repeated string feature_toggle_id = 1;
     */
    featureToggleId = [];
    /**
     * optional - call is more efficient if set
     *
     * @generated from field: string brand_code = 2;
     */
    brandCode = "";
    /**
     * optional - call is more efficient if set
     *
     * @generated from field: string customer_group_code = 3;
     */
    customerGroupCode = "";
    /**
     * optional - call is more efficient if set
     *
     * @generated from field: string language_code = 4;
     */
    languageCode = "";
    /**
     * optional - call is more efficient if set
     *
     * @generated from field: string email = 7;
     */
    email = "";
    /**
     * @generated from field: bool is_qa = 5;
     */
    isQa = false;
    /**
     * optional
     *
     * @generated from field: string hostname = 6;
     */
    hostname = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.feature.v2.GetFeatureTogglesRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "feature_toggle_id", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
        { no: 2, name: "brand_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "customer_group_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "language_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 7, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "is_qa", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 6, name: "hostname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetFeatureTogglesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFeatureTogglesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFeatureTogglesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFeatureTogglesRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.feature.v2.GetFeatureTogglesResponse
 */
export class GetFeatureTogglesResponse extends Message {
    /**
     * @generated from field: repeated string active_feature_toggle_id = 1;
     */
    activeFeatureToggleId = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.feature.v2.GetFeatureTogglesResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "active_feature_toggle_id", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetFeatureTogglesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFeatureTogglesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFeatureTogglesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFeatureTogglesResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.feature.v2.GetFeatureConfigRequest
 */
export class GetFeatureConfigRequest extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.feature.v2.Feature feature = 1;
     */
    feature = [];
    /**
     * optional - call is more efficient if set
     *
     * @generated from field: string customer_group_code = 2;
     */
    customerGroupCode = "";
    /**
     * optional
     *
     * @generated from field: string hostname = 3;
     */
    hostname = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.feature.v2.GetFeatureConfigRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "feature", kind: "enum", T: proto3.getEnumType(Feature), repeated: true },
        { no: 2, name: "customer_group_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "hostname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetFeatureConfigRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFeatureConfigRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFeatureConfigRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFeatureConfigRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.feature.v2.GetFeatureConfigResponse
 */
export class GetFeatureConfigResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.feature.v2.Feature active_feature = 1;
     */
    activeFeature = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.feature.v2.GetFeatureConfigResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "active_feature", kind: "enum", T: proto3.getEnumType(Feature), repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetFeatureConfigResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFeatureConfigResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFeatureConfigResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFeatureConfigResponse, a, b);
    }
}
